import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function SessionTypeSvg({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <SvgIcon
            viewBox="0 0 18 18"
            sx={{
                width: 18,
                height: 18,
                fill: "none",

                ...sx,
            }}
        >
            <path
                d="M5.1 3.33333V8L6.725 7L8.35 8V3.33333H5.1ZM12.25 16C11.3508 16 10.5844 15.675 9.95063 15.025C9.31687 14.375 9 13.5889 9 12.6667C9 11.7444 9.31687 10.9583 9.95063 10.3083C10.5844 9.65833 11.3508 9.33333 12.25 9.33333C13.1492 9.33333 13.9156 9.65833 14.5494 10.3083C15.1831 10.9583 15.5 11.7444 15.5 12.6667C15.5 13.5889 15.1831 14.375 14.5494 15.025C13.9156 15.675 13.1492 16 12.25 16ZM11.4375 14.3333L14.0375 12.6667L11.4375 11V14.3333ZM7.7 12.6622C7.7 13.1429 7.77313 13.6083 7.91938 14.0583C8.06563 14.5083 8.26333 14.9333 8.5125 15.3333H3.8C3.4425 15.3333 3.13646 15.2028 2.88188 14.9417C2.62729 14.6806 2.5 14.3667 2.5 14V3.33333C2.5 2.96667 2.62729 2.65278 2.88188 2.39167C3.13646 2.13056 3.4425 2 3.8 2H11.6C11.9575 2 12.2635 2.13056 12.5181 2.39167C12.7727 2.65278 12.9 2.96667 12.9 3.33333V8.03333C12.791 8.02222 12.682 8.01389 12.5729 8.00833C12.4639 8.00278 12.3549 8 12.2458 8C10.9811 8 9.90729 8.45278 9.02438 9.35833C8.14146 10.264 7.7 11.3653 7.7 12.6622Z"
                fill="white"
            />
        </SvgIcon>
    );
}
